<footer class="mt-auto border-t border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 transition-colors duration-300">
  <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
    <div class="flex flex-col sm:flex-row items-center justify-between gap-4">
      <p class="text-sm text-gray-500 dark:text-gray-400">
        &copy; {{ year }} <span class="font-medium text-gray-700 dark:text-gray-300">habitualcs.io</span>. All rights reserved.
      </p>
      <nav class="flex items-center gap-4 text-sm text-gray-500 dark:text-gray-400" aria-label="Footer navigation">
        <a routerLink="/about" class="hover:text-gray-700 dark:hover:text-gray-200 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--reader-accent)] rounded">About</a>
        <a routerLink="/contact" class="hover:text-gray-700 dark:hover:text-gray-200 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--reader-accent)] rounded">Contact</a>
      </nav>
    </div>
  </div>
</footer>
